import { createStyle } from "~/common/utils/create-style";

export const dataSourceListStyle = createStyle({
  slots: {
    container: "text-center gap-y-12 flex flex-col",
    source:
      "flex p-8 border-1 rounded-l border-gray-solid-200 shadow-sm cursor-pointer",
    icon: "w-32 h-32 flex justify-center content items-center",
    title: "pl-8 text-body-2 self-center",
    connection: "ml-auto text-body-3 self-center text-system-on-light-green-01",
    checkIcon: "pl-4 inline",
  },
  variants: {
    variant: {
      inactive: { connection: "grayscale opacity-50" },
    },
  },
})();
